module.exports = __webpack_public_path__ + "static/media/part-return-slide-6.eb9d899e.jpg";